let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bDI57")).then(() => parcelRequire('hvHzV'));